import { apiClient } from "../config";

async function getImportInfo(id: number) {
  const res = await apiClient.get(`/admin/observations/${id}/import-info`);
  return res.data;
}

export default getImportInfo;

